import { css } from 'styled-components';

const breakpoints = {
  xs: 0,
  sm: 544,
  md: 768,
  lg: 992,
  xl: 1281,
};

const breakpointUp = size => styles => css`
  @media (min-width: ${size}px) {
    ${styles}
  };
`;

const breakpointDown = size => styles => css`
  @media (max-width: ${size - 1}px) {
    ${styles}
  };
`;

const breakpointBetweenAny = (min, max) => styles => css`
  @media (min-width: ${min}px) and (max-width: ${max - 1}px) {
    ${styles}
  };
`;

export default {
  ...breakpoints,
  breakpointBetweenAny,
  breakpointUp,
  breakpointDown,
};
